

export const wanFeatures = {
    title: '为什么 Wan 2.5 是最先进的 AI 视频生成器',
    items: [
      { num: '01', title: '原生音频生成（行业首创）', text: 'Wan 2.5 同时生成视频与音频：唇形对齐的同步对白、与画面节奏匹配的背景音乐、环境声与氛围音效。' },
      { num: '02', title: '卓越稳定与连贯运镜', text: '进阶摄影语言带来平滑转场与稳定追踪。专业级运镜与自然动势。' },
      { num: '03', title: '灵活时长与多分辨率支持', text: '生成 5 秒或 10 秒视频。多种比例：16:9 横向、9:16 纵向、1:1 方形。社媒平台优化。' },
      { num: '04', title: '最大创作自由与多元内容', text: '宽松内容审核允许大胆、动态创作。支持文字、图片与音频参考等多模态输入，并具优秀多语言支持。' }
    ]
  };
